export default "__VITE_ASSET__0L$u60lB__"